/* eslint-disable import/no-unresolved */
export { unstable_batchedUpdates } from 'react-dom';


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-redux/es/utils/reactBatchedUpdates.js
// module id = 1186
// module chunks = 0